import type { InstaStackCollection } from './types';
import { axiosClient } from '../axiosClient';

export const getInstaStackCollections = () => {
  return axiosClient.get<InstaStackCollection[]>('/instastack/collection');
};
